import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  // Navigate,
} from "react-router-dom";
import "./App.css";
import Header from "./components/navbar/Header";
import HomePage from "./pages/HomePage";
import CreateJobPage from "./pages/CreateJobPage";
import EditJobPage from "./pages/EditJobPage";
import Layout from "./components/Layout";
import Sidebar from "./components/sidebar/Sidebar";

const App = () => {
  return (
    <Router>
      <Header />
      <Layout>
        <Sidebar />
        <div className="lg:pl-[14rem]  mt-[5.8125rem]">
          <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
            <Routes>
              {/* <Route path="/" element={<Navigate to="/jobs" />} /> */}
              <Route path="/" element={<HomePage />} />
              <Route path="/create" element={<CreateJobPage />} />
              <Route path="/edit-job/:jobId" element={<EditJobPage />} />
            </Routes>
          </main>
        </div>
      </Layout>
    </Router>
  );
};

export default App;
